/** Canonical keys are the original French strings; values are Brazilian Portuguese. */
export const commonPtBR: Record<string, string> = {
  Français: "Francês",
  "Portugais (Brésil)": "Português (Brasil)",
  Langue: "Idioma",
  "Choisir la langue": "Escolher o idioma",
  "Changer de langue": "Mudar de idioma",
  "Couper le son": "Desativar o som",
  "Copier le lien d’invitation": "Copiar o link de convite",
  Niveau: "Nível",
  "Niveau {level}": "Nível {level}",
  "NIVEAU {level}": "NÍVEL {level}",
  "Niveau {level}, {xp} XP. Voir mes badges":
    "Nível {level}, {xp} XP. Ver minhas conquistas",
  "{xp} XP AU TOTAL": "{xp} XP NO TOTAL",
  "{current} / {needed} XP vers le niveau {level}":
    "{current} / {needed} XP para o nível {level}",
  "NIVEAU {level} DÉBLOQUÉ · Tes réflexes montent d’un cran !":
    "NÍVEL {level} DESBLOQUEADO · Seus reflexos estão cada vez melhores!",
  "NIV. {level}": "NÍV. {level}",
  "NIV.": "NÍV.",
  "NV.": "NV.",
  "Niv. {level}": "Nív. {level}",
  XP: "XP",
  "{current} / {needed} XP": "{current} / {needed} XP",
  "Carte {number}": "Carta {number}",
  "Carte {id}": "Carta {id}",
  "Carte du centre": "Carta central",
  "Votre carte": "Sua carta",
  "Ta carte": "Sua carta",
  "Carte du centre : choisissez le symbole commun":
    "Carta central: escolha o símbolo em comum",
  "Votre carte : choisissez le symbole commun":
    "Sua carta: escolha o símbolo em comum",
  "Carte du centre : trouve le symbole commun":
    "Carta central: encontre o símbolo em comum",
  "Ta carte : trouve le symbole commun":
    "Sua carta: encontre o símbolo em comum",
  "Carte du centre : touche le symbole commun":
    "Carta central: toque no símbolo em comum",
  "Ta carte : touche le symbole commun": "Sua carta: toque no símbolo em comum",
  "{count} carte": "{count} carta",
  "{count} cartes": "{count} cartas",
  "{count} symbole": "{count} símbolo",
  "{count} symboles": "{count} símbolos",
  "{count} joueur": "{count} jogador",
  "{count} joueurs": "{count} jogadores",
  "{count} victoire": "{count} vitória",
  "{count} victoires": "{count} vitórias",
  "{count} erreur": "{count} erro",
  "{count} erreurs": "{count} erros",
  "Premier éclair": "Primeiro raio",
  "Œil affûté": "Olhar afiado",
  "Cent symboles": "Cem símbolos",
  "Sans faute": "Sem errar",
  "Première couronne": "Primeira coroa",
  "Échauffé à bloc": "Aquecimento completo",
  "Trouver ton premier symbole commun.":
    "Encontre seu primeiro símbolo em comum.",
  "Trouver votre premier symbole commun.":
    "Encontre seu primeiro símbolo em comum.",
  "Trouver 25 symboles communs.": "Encontre 25 símbolos em comum.",
  "Trouver 100 symboles communs.": "Encontre 100 símbolos em comum.",
  "Enchaîner 5 bonnes réponses sans erreur.":
    "Acerte 5 respostas seguidas sem errar.",
  "Remporter une partie multijoueur.": "Vença uma partida multijogador.",
  "Terminer 3 entraînements.": "Conclua 3 treinos.",
  Débloqué: "Desbloqueado",
  Verrouillé: "Bloqueado",
  "Succès débloqué": "Conquista desbloqueada",
  "Nouveau niveau !": "Novo nível!",
  "Virou! - {count} cartes": "Virou! - {count} cartas",
  "Jeu complet, {density} carte(s) par page, diametre {diameter} mm":
    "Jogo completo, {density} carta(s) por página, diâmetro {diameter} mm",
  "Jeu complet, {density} carte(s) par page, diamètre {diameter} mm":
    "Jogo completo, {density} carta(s) por página, diâmetro {diameter} mm",
  "Virou! | Diametre {diameter} mm | Taille reelle 100 % | Decouper les cercles":
    "Virou! | Diametro {diameter} mm | Tamanho real 100 % | Recorte os circulos",
  "Virou! | Diamètre {diameter} mm | Taille réelle 100 % | Découper les cercles":
    "Virou! | Diâmetro {diameter} mm | Tamanho real 100 % | Recorte os círculos",
  "Controle : 50 mm": "Controle: 50 mm",
  "Contrôle : 50 mm": "Controle: 50 mm",
  "L’illustration « {name} » ne répond pas ({path}). Réessayez l’export.":
    "A ilustração “{name}” não está respondendo ({path}). Tente exportar novamente.",
  "L’illustration « {name} » est vide ({path}).":
    "A ilustração “{name}” está vazia ({path}).",
  "Impossible de charger l’illustration « {name} » ({path}). Vérifiez son fichier et l’autorisation CORS.":
    "Não foi possível carregar a ilustração “{name}” ({path}). Verifique o arquivo e a permissão de CORS.",
  "Une illustration bloque la création du PDF. Utilisez des images locales ou activez CORS sur leur serveur.":
    "Uma ilustração está impedindo a criação do PDF. Use imagens locais ou ative o CORS no servidor das imagens.",
  "Votre navigateur ne permet pas de dessiner les cartes pour le PDF.":
    "Seu navegador não permite desenhar as cartas para o PDF.",
  "Ton navigateur ne permet pas de dessiner les cartes pour le PDF.":
    "Seu navegador não permite desenhar as cartas para o PDF.",
  "Préparation des cartes : {current} / {total}":
    "Preparando as cartas: {current} / {total}",
  "Préparation des planches…": "Preparando as páginas…",
  "L’export n’a pas abouti. Vous pouvez réessayer.":
    "A exportação não foi concluída. Você pode tentar novamente.",
  "Impossible de préparer le PDF.": "Não foi possível preparar o PDF.",
  "Choisissez un paquet de 4, 6 ou 8 symboles par carte.":
    "Escolha um baralho com 4, 6 ou 8 símbolos por carta.",
  "Cette partie a déjà commencé.": "Esta partida já começou.",
  "Le salon est complet (8 joueurs).": "A sala está cheia (8 jogadores).",
  "Session invalide.": "Sessão inválida.",
  "Cette session a expiré. Rejoignez le salon à nouveau.":
    "Esta sessão expirou. Entre na sala novamente.",
  "La partie a déjà commencé.": "A partida já começou.",
  "Terminez la partie avant de rejouer.":
    "Termine a partida antes de jogar novamente.",
  "La partie n’est pas en cours.": "A partida não está em andamento.",
  "La carte vient de changer. Regardez la nouvelle carte.":
    "A carta acabou de mudar. Veja a nova carta.",
  "Symbole invalide.": "Símbolo inválido.",
  "Ce symbole n’est pas commun aux deux cartes.":
    "Este símbolo não aparece nas duas cartas.",
  "Il faut au moins 2 joueurs connectés pour commencer.":
    "É preciso ter pelo menos 2 jogadores conectados para começar.",
  "Salon introuvable ou expiré.": "Sala não encontrada ou expirada.",
  "Ce salon a expiré.": "Esta sala expirou.",
  "Rejoignez ce salon pour jouer.": "Entre nesta sala para jogar.",
  "Seul l’hôte peut lancer la partie.":
    "Somente o anfitrião pode iniciar a partida.",
  "Pseudo invalide.": "Apelido inválido.",
  "Le pseudo doit contenir entre 1 et 24 caractères.":
    "O apelido deve ter entre 1 e 24 caracteres.",
  "Code du salon invalide.": "Código da sala inválido.",
  "Le code du salon doit contenir 6 caractères.":
    "O código da sala deve ter 6 caracteres.",
  "Trop de connexions. Réessayez dans un instant.":
    "Muitas conexões. Tente novamente em instantes.",
  "Origine invalide.": "Origem inválida.",
  "Cette session a été ouverte dans un autre onglet.":
    "Esta sessão foi aberta em outra aba.",
  "Un peu trop vite ! Réessayez dans un instant.":
    "Um pouco rápido demais! Tente novamente em instantes.",
  "Une erreur est survenue. Réessayez.": "Ocorreu um erro. Tente novamente.",
  "Rejoignez d’abord un salon.": "Entre em uma sala primeiro.",
  "Requête invalide.": "Solicitação inválida.",
  "Introuvable.": "Não encontrado.",
  "Le salon a expiré après une période d’inactivité.":
    "A sala expirou após um período de inatividade.",
  "Le salon est vide.": "A sala está vazia.",
};

/** IDs match shared/symbols.ts and never depend on the selected language. */
export const symbolNamesPtBR: readonly string[] = [
  "Timbu masculino",
  "Mascote feminina do Náutico",
  "Escudo do Náutico",
  "Camisa do Náutico",
  "Bola de futebol",
  "Chuteira",
  "Luva de goleiro",
  "Gol de futebol",
  "Taça de campeão",
  "Apito",
  "Cartões amarelo e vermelho cruzados",
  "Chave do Carnaval de Olinda",
  "Rádio de torcedor",
  "Tambor da torcida",
  "Megafone",
  "Ingresso de jogo",
  "Bandeira do Náutico",
  "Medalha de campeão",
  "Âncora",
  "Estádio dos Aflitos e sede",
  "Remos cruzados",
  "Galo da Madrugada",
  "Bandeira de Pernambuco",
  "Mapa do Brasil",
  "Tucano",
  "Arara multicolorida",
  "Onça-pintada",
  "Tubarão de Boa Viagem",
  "Coqueiro de Boa Viagem",
  "Jangada",
  "Caranguejo do manguebeat",
  "Torre de Cristal de Brennand",
  "Rosa dos ventos do Marco Zero",
  "Ponte Maurício de Nassau",
  "Casarões da Rua do Bom Jesus",
  "Sombrinha de frevo",
  "Pandeiro",
  "Caboclo de lança do maracatu",
  "Boi Voador",
  "Saci-Pererê",
  "La Ursa",
  "Papangu de Bezerros",
  "Homem da Meia-Noite",
  "Cuca",
  "Boitatá",
  "Carranca do São Francisco",
  "Chapéu de cangaceiro",
  "Sanfona de forró",
  "Fogueira de São João",
  "Lata de Guaraná Jesus",
  "Garrafa de Pitú",
  "Coxinha",
  "Cuscuz na cuscuzeira",
  "Bolo de rolo",
  "Tapioca",
  "Caju",
  "Açaí"
];
